import useGetUserSubscriptionDetails from 'hooks/useGetUserSubscriptionDetails';
import React, { useEffect } from 'react';

interface UserSubscriberLoaderProps {
  isAuthorized: boolean;
  user?: { uid: string } | null;
  setSubscriptionDetails: (details: any) => void;
  setIsSubscriptionDetailsLoading: (loading: boolean) => void;
}

const UserSubscriberLoader: React.FC<UserSubscriberLoaderProps> = ({
  isAuthorized,
  user,
  setSubscriptionDetails,
  setIsSubscriptionDetailsLoading
}) => {
  const { userSubscriptionDetails, isSubscriptionDetailsLoading } =
    useGetUserSubscriptionDetails({
      userId: isAuthorized && user?.uid ? user.uid : undefined
    });

  useEffect(() => {
    setSubscriptionDetails(userSubscriptionDetails);
    setIsSubscriptionDetailsLoading(isSubscriptionDetailsLoading);
  }, [
    isSubscriptionDetailsLoading,
    userSubscriptionDetails,
    setIsSubscriptionDetailsLoading,
    setSubscriptionDetails
  ]);

  return null;
};

export default UserSubscriberLoader;
